import { ENTITIES } from 'constants/common'
import keymirror from 'keymirror'

export enum MESSAGE_TYPES {
  info = 'info',
  primary = 'primary',
  success = 'success',
  warning = 'warning',
  error = 'error',
}

export const MESSAGE_ENTITIES = {
  ...ENTITIES,
  [ENTITIES.ancillaryData]: 'data',
}

export const MESSAGE_STATUS = keymirror({
  save: null,
  saved: null,
  saving: null,
  update: null,
  updated: null,
  updating: null,
  delete: null,
  deleted: null,
  deleting: null,
  fetch: null,
  fetched: null,
  fetching: null,
  share: null,
  shared: null,
  sharing: null,
  clone: null,
  cloned: null,
  cloning: null,
  create: null,
  created: null,
  creating: null,
})

export const REQUIRED_FIELD_ERROR_MESSAGE = 'This field is required'

export const INCORRECT_TOTP_ERROR_MESSAGE =
  'Invalid MFA code. Enter the code displayed on your security app'

export const INCORRECT_TOTP_ERROR_MESSAGE_WITH_SCAN = `${INCORRECT_TOTP_ERROR_MESSAGE} or try scanning or entering the number again`

export const INCORRECT_SMS_ERROR_MESSAGE =
  'Invalid MFA code. Enter the code sent to the above mobile phone number or try sending the code again.'

export const SESSION_NOT_FOUND_ERROR_MESSAGE = 'Session not found'

export const REAUTH_MAX_ATTEMPTS_REACHED_ERROR_MESSAGE =
  'Maximum number of attempts reached'

export const INVALID_MFA_CODE_API_RESPONSE_ERROR_MESSAGE = 'Invalid MFA code'

export const CONFIRM_SIGN_IN_FAILED_API_RESPONSE_ERROR_MESSAGE =
  'Confirm sign in failed.'

export const DEFAULT_MFA_ERROR_MESSAGE =
  'Failed to validate the MFA code. The code might be expired or incorrect.'
